import { CODE_ENV_LIST, JOIN_TYPE } from '@/common/constants/ConstCode';
import store from '@/store';
import { isApp } from '@/common/utils/module/IsMobileSupport';
import { showTextModal } from '@/common/utils/ModalState';

const { APP_SCHEMA } = CODE_ENV_LIST;

export const purchaseCall = productId => {
  console.log('인앱 구매 요청 productId :: {}', productId);
  store.dispatch('layout/updateIsLoading', { isLoading: true });

  nativeInAppPurchase(productId);
};

/**
 *  call
 * @return ''
 * @class Util
 */
export const nativeTel = tel => {
  location.href = `tel:${tel}`;
};
// 현재 url 공유
export const nativeIntentShareUrl = result => {
  if (isApp()) {
    nativeShareUrl(result);
  } else {
    navigator.clipboard.writeText(result).then(() => {
      showTextModal('현재 URL 주소가 복사되었습니다.', '확인');
    });
  }
};

/**
 * 디바이스 정보 native call
 * @return callBack(deviceTypeID, deviceID, registrationKey, isFirst)
 * @class Util
 * @param callBack
 */
export const nativeGetRegistrationKey = callBack => {
  location.href = `native://action.${APP_SCHEMA}?cmd=getRegistrationKey&callback=${callBack}`;
};

/**
 * SMS 자동 읽기 리스너 시작
 * @param callBack - 인증번호 6자리를 받을 콜백 함수명
 */
export const nativeStartSmsListener = callBack => {
  location.href = `native://action.${APP_SCHEMA}?cmd=startSmsListener&callback=${callBack}`;
};

/**
 * 캐시 초기화
 * @return ''
 * @class Util
 */
export const nativeClearCache = () => {
  location.href = `native://action.${APP_SCHEMA}?cmd=clearCache`;
};


/**
 * 기본 텍스트 공유
 * @param data(Intent 공유할 메세지 혹은 url)
 * @return ''
 * @class Util
 */
export const nativeShareText = data => {
  location.href = `native://action.${APP_SCHEMA}?cmd=shareText&callback=CALLBACK&content=${encodeURIComponent(data)}`;
  return '';
};

/**
 * 기본 텍스트 공유
 * @param data(Intent 공유할 메세지 혹은 url)
 * @return ''
 * @class Util
 */
export const nativeShareUrl = data => {
  location.href = `native://action.${APP_SCHEMA}?cmd=shareUrl&callback=CALLBACK&url=${encodeURIComponent(data)}`;
  return '';
};

/**
 * 카카오 공유
 * @param data(Intent 공유할 메세지 혹은 url)
 * @return ''
 * @class Util
 */
export const nativeShareKaKao = data => {
  data += '&rUrl=/main/map';
  location.href = `native://action.${APP_SCHEMA}?cmd=shareKaKao&callback=CALLBACK&url=${encodeURIComponent(data)}`;
  return '';
};

/**
 * SHOW SMS
 * @param data(휴대폰번호)
 * @return ''
 * @class Util
 */
export const nativeShowSms = data => {
  location.href = `native://action.${APP_SCHEMA}?cmd=showSms&callback=CALLBACK&data=${data}`;
};

/**
 * 강제 인트로 HIDE
 * @return ''
 * @class Util
 */
export const nativeHideIntro = () => {
  location.href = `native://action.${APP_SCHEMA}?cmd=hideIntro`;
};

/**
 * 디바이스 최초 실행 여부
 * @return ''
 * @class Util
 */
export const nativeFirstRun = callBack => {
  location.href = `native://action.${APP_SCHEMA}?cmd=firstRun&callback=${callBack}`;
};

/**
 * 카메라 권한 여부
 * @return 승인: '1', 거부 or 응답전: '-1'
 * @class Util
 */
export const nativeCameraPermission = callBack => {
  location.href = `native://action.${APP_SCHEMA}?cmd=cameraPermission&callback=${callBack}`;
};

/**
 * 커스텀 카메라 뷰 이동
 * @return 이미지 데이터 (alert 64)
 * @class Util
 */
export const nativeCaptureCard = callBack => {
  location.href = `native://action.${APP_SCHEMA}?cmd=captureCard&callback=${callBack}`;
};

/**
 * 앱 설정 페이지로 보내기
 * @class Util
 */
export const nativeGoToSetting = () => {
  location.href = `native://action.${APP_SCHEMA}?cmd=goToSetting`;
};

/**
 * 외부링크 URL 호출시
 * @return ''
 * @class Util
 */
export const nativeLink = link => {
  location.href = `native://action.${APP_SCHEMA}?cmd=browse&url=${encodeURIComponent(link)}`;
};

/**
 * 티맵 길찾기(앱-투-앱 스킴). goalx=경도(lng), goaly=위도(lat) — 순서 주의.
 * 주의: tmap:// 스킴은 iOS Info.plist(LSApplicationQueriesSchemes)와 Android <queries>에 등록돼 있어야 실행됨.
 * 앱 내부는 browse 브릿지(nativeLink), 앱 외부(모바일웹)는 location.href로 직접 스킴 호출.
 */
export const nativeTmapRoute = (name, lng, lat) => {
  const url = `tmap://route?goalname=${encodeURIComponent(name || '목적지')}&goalx=${lng}&goaly=${lat}`;
  if (isApp()) nativeLink(url);
  else location.href = url;
};

/**
 * native 위/경도 가져오기
 */
export const nativeGpsLocation = () => {
  location.href = `native://action.${APP_SCHEMA}?cmd=getLocation&callback=setNativeLocation`;
};

/**
 * native 위치 기능 설정 열기
 */
export const nativeGpsSetting = () => {
  location.href = `native://action.${APP_SCHEMA}?cmd=gpsSetting`;
};

/**
 * SNS 로그인
 * @param type
 */
// 타입: 네이버(N), 카카오(K), 애플(A), 구글(G), 페이스북(F)
export const nativeSnsLogin = (type = '') => {
  console.log('SNS 타입', type);
  console.log('앱스키마', APP_SCHEMA);
  if (type === JOIN_TYPE.NAVER.value) store.commit('user/setJoinType', JOIN_TYPE.NAVER.value);
  if (type === JOIN_TYPE.GOOGLE.value) store.commit('user/setJoinType', JOIN_TYPE.GOOGLE.value);
  if (type === JOIN_TYPE.KAKAO.value) store.commit('user/setJoinType', JOIN_TYPE.KAKAO.value);
  if (type === JOIN_TYPE.APPLE.value) store.commit('user/setJoinType', JOIN_TYPE.APPLE.value);

  location.href = `native://action.${APP_SCHEMA}?cmd=loginForSns&type=${type}&callback=loginForSnsCallback`;
};

export const nativeInAppPurchase = (productID = '') => {
  console.log('인앱 Request :: {}', productID);
  location.href = `native://action.${APP_SCHEMA}?cmd=payment&productId=${productID}&callback=inAppPurchase`;
};

/**
 * 다이나믹 링크
 */
export const nativeDynamicLinkIOS = payload => {
  // location.href = `native://action.${APP_SCHEMA}?cmd=dynamicLink`;
  location.href = `native://action.${APP_SCHEMA}?cmd=getDynamicLink&callback=onDynamicLink`;
};

export const nativeDynamicLinkAOS = payload => {
  // location.href = `native://action.${APP_SCHEMA}?cmd=dynamicLink`;
  location.href = `https://link-test.appgdev.co.kr/link=${payload}`;
};

export const nativeDownload = (url, fileName) => {
  location.href = `native://action.${APP_SCHEMA}?cmd=downloadFile&url=${encodeURIComponent(url)}&fileName=${fileName}`;
};

/**
 * 텍스트 복사
 * @param content
 */
export const nativeCopyText = (content = '') => {
  location.href = `native://action.${APP_SCHEMA}?cmd=copy&content=${content}`;
};
export const nativeFinish = () => {
  location.href = `native://action.${APP_SCHEMA}?cmd=finish`;
};
// MEMO: 안드로이드 클립보드 복사 권한 이슈 대응
export const androidCopy = text => {
  location.href = `native://action.${APP_SCHEMA}?cmd=copy&content=${text}`;
};
